namespace NasVault {
  function uploadRow(file: File, stateName: UploadState = "waiting", message = "대기", percent = 0): HTMLElement {
    const duplicate = state.currentItems.some((item) => item.type === "file" && item.name === file.name);
    const row = document.createElement("div");
    row.className = `nas-upload-row ${stateName}`;
    row.dataset.fileName = file.name;
    row.innerHTML = `
      <div class="nas-upload-row-head">
        <span class="nas-upload-file-name"></span>
        <span class="nas-badge ${stateName}"></span>
      </div>
      <div class="nas-upload-file-meta"></div>
      <div class="nas-progress" role="progressbar" aria-label="업로드 진행률" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${percent}">
        <div class="nas-progress-indicator" style="width:${percent}%"></div>
      </div>`;
    const name = row.querySelector(".nas-upload-file-name");
    const badge = row.querySelector(".nas-badge");
    const meta = row.querySelector(".nas-upload-file-meta");
    if (name) name.textContent = file.name;
    if (badge) badge.textContent = message;
    if (meta) meta.textContent = `${sizeLabel(file.size)}${duplicate && stateName === "waiting" ? " · 기존 파일을 덮어씁니다" : ""}`;
    return row;
  }

  function updateUploadRow(file: File, stateName: UploadState, message: string, percent: number): void {
    const queue = element("nasUploadQueue");
    const row = Array.from(queue?.querySelectorAll<HTMLElement>(".nas-upload-row") || [])
      .find((candidate) => candidate.dataset.fileName === file.name);
    if (!row) return;
    row.className = `nas-upload-row ${stateName}`;
    const badge = row.querySelector(".nas-badge");
    const progress = row.querySelector<HTMLElement>(".nas-progress");
    const indicator = row.querySelector<HTMLElement>(".nas-progress-indicator");
    if (badge) { badge.className = `nas-badge ${stateName}`; badge.textContent = message; }
    if (progress) progress.setAttribute("aria-valuenow", String(percent));
    if (indicator) indicator.style.width = `${percent}%`;
  }

  export function closeUploadDialog(): void {
    state.pendingFiles = [];
    const dialog = element("nasUploadDialog");
    if (dialog) dialog.hidden = true;
  }

  export function requestUpload(files: File[]): void {
    if (!state.canWrite) {
      state.pendingFiles = [];
      setStatus("이 폴더에는 파일을 업로드할 수 없어요.", true);
      return;
    }
    state.pendingFiles = [...files];
    if (!state.pendingFiles.length) {
      setStatus("업로드할 파일을 찾지 못했어요.", true);
      return;
    }
    const target = element("nasUploadTarget");
    if (target) target.textContent = `${state.currentPath} 폴더에 ${state.pendingFiles.length}개 파일을 업로드합니다.`;
    const queue = element("nasUploadQueue");
    if (queue) {
      queue.textContent = "";
      state.pendingFiles.forEach((file) => queue.append(uploadRow(file)));
    }
    const confirmButton = element<HTMLButtonElement>("nasUploadConfirm");
    const cancelButton = element<HTMLButtonElement>("nasUploadCancel");
    if (confirmButton) { confirmButton.disabled = false; confirmButton.textContent = "업로드"; }
    if (cancelButton) { cancelButton.disabled = false; cancelButton.hidden = false; }
    const dialog = element("nasUploadDialog");
    if (dialog) dialog.hidden = false;
  }

  export async function uploadPendingFiles(): Promise<void> {
    const files = [...state.pendingFiles];
    if (!files.length) { closeUploadDialog(); return; }
    const confirmButton = element<HTMLButtonElement>("nasUploadConfirm");
    const cancelButton = element<HTMLButtonElement>("nasUploadCancel");
    if (confirmButton) { confirmButton.disabled = true; confirmButton.textContent = "업로드 중…"; }
    if (cancelButton) cancelButton.disabled = true;
    let succeeded = 0;
    for (const file of files) {
      updateUploadRow(file, "uploading", "업로드 중", 0);
      try {
        await api.upload(file, state.currentPath, (percent) => updateUploadRow(file, "uploading", `${percent}%`, percent));
        updateUploadRow(file, "success", "완료", 100);
        succeeded += 1;
      } catch (error) {
        updateUploadRow(file, "error", "실패", 100);
        const row = element("nasUploadQueue")?.querySelector<HTMLElement>(`[data-file-name="${CSS.escape(file.name)}"] .nas-upload-file-meta`);
        if (row) row.textContent = error instanceof Error ? error.message : "업로드하지 못했어요.";
      }
    }
    state.pendingFiles = [];
    if (confirmButton) { confirmButton.disabled = false; confirmButton.textContent = "닫기"; }
    if (cancelButton) cancelButton.hidden = true;
    const failed = succeeded !== files.length;
    setStatus(`${succeeded}/${files.length}개 파일을 업로드했어요.${failed ? " 실패 항목을 확인해 주세요." : ""}`, failed);
    await load(state.currentPath);
  }

  export function bindUploadDialog(): void {
    element("nasUploadCancel")?.addEventListener("click", closeUploadDialog);
    element("nasUploadConfirm")?.addEventListener("click", () => void uploadPendingFiles());
    element("nasUploadDialog")?.addEventListener("click", (event) => {
      if (event.target === event.currentTarget && !state.pendingFiles.length) closeUploadDialog();
    });
  }
}
